import { styled } from "@mui/material";

export const Container = styled("div")`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const LeftPanel = styled("div")`
  width: 200px;
  > div {
    width: 100%;
    height: 100%;
    max-width: 360px;
    overflow: auto;
  }
`;

export const RightPanel = styled("div")`
  flex-grow: 1;
`;
